/**
 * ImpressionEventObserver: Class to be able to check when an element was viewed for impression event purposes.
 * As the impression events should be triggerred once, the element should be unobserve when it was
 * on the viewport according to IntersectionObserver API.
 */
export default class ImpressionEventObserver {
  constructor(callbackOnIntersection, options){
    const defaultOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0
    };
    
    const intersectionHandler = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const intersectedElement = entry.target;
          callbackOnIntersection(intersectedElement);
          observer.unobserve(intersectedElement)
        }
      });
    }
    
    this.intersectionObserver = new IntersectionObserver(intersectionHandler, options || defaultOptions);
  }
  
  /**
   * getIntersectionObserver: Gets the IntersectionObserver API object to be able to observe the elements.
   * @returns The IntersectionObserver API object.
   */
  getIntersectionObserver = () => this.intersectionObserver;
}